import { requestSparePartsList } from "constants/requestSpareParts";

const initialState = {
  requestSparePartsList: {},
};

const requestSpareParts = (state = initialState, action) => {
  switch (action.type) {
    case requestSparePartsList:
      return { ...state, requestSparePartsList: action.payload };
    default:
      return state;
  }
};

export default requestSpareParts;
